import {
  CLIENT_TYPES,
  MARITAL_PROPERTY_REGIMES,
  MARITAL_STATUSES,
  type ClientType,
  type MaritalPropertyRegime,
  type MaritalStatus,
} from "../types";

/**
 * Choices for the client type enum ('persona_fisica' | 'persona_moral').
 * SelectInput/SelectField translate a choice's `name` as a message key by
 * default, so these keys must exist in every locale's crm messages file.
 */
export const CLIENT_TYPE_CHOICES: Array<{ id: ClientType; name: string }> =
  CLIENT_TYPES.map((clientType) => ({
    id: clientType,
    name: `resources.clients.client_type.${clientType}`,
  }));

/** Choices for the marital status enum, shown on the client show page. */
export const MARITAL_STATUS_CHOICES: Array<{
  id: MaritalStatus;
  name: string;
}> = MARITAL_STATUSES.map((status) => ({
  id: status,
  name: `resources.clients.marital_status.${status}`,
}));

/**
 * Choices for the marital property regime enum, shown on the client
 * create/edit form (only when marital status is casado) and on the client
 * show page.
 */
export const MARITAL_PROPERTY_REGIME_CHOICES: Array<{
  id: MaritalPropertyRegime;
  name: string;
}> = MARITAL_PROPERTY_REGIMES.map((regime) => ({
  id: regime,
  name: `resources.clients.marital_property_regime.${regime}`,
}));
